import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/polymerize/navFlow',
  owner: '/home',
  authority: 'navFlowList',
  component: Loadable({
    loader: () => import('.'),
    loading: () => <RouteLoading />
  })
};